exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".RichTextView__text__3N63H p{margin:0}.RichTextView__text__3N63H>span{word-break:break-word}", "", {"version":3,"sources":["/mnt/d/asofts/vvs/cirrus/Cirrus/frontend/src/components/controls/src/components/controls/RichTextView.scss"],"names":[],"mappings":"AAAA,6BAEI,QAAS,CACV,AAHH,gCAMI,qBAAsB,CACvB","file":"RichTextView.scss","sourcesContent":[".text {\n  p {\n    margin: 0;\n  }\n\n  > span {\n    word-break: break-word;\n  }\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"text": "RichTextView__text__3N63H"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-2!./node_modules/sass-loader/lib/loader.js??ref--1-3!./src/components/controls/RichTextView.scss
// module id = ./node_modules/css-loader/index.js??ref--1-2!./node_modules/sass-loader/lib/loader.js??ref--1-3!./src/components/controls/RichTextView.scss
// module chunks = 0